<ng-container class="cursor-pointer text-blue-500 underline"> v{{ applicationVersion }} </ng-container>
